export function timeoutable<T>(action: () => Promise<T>, timeout: number): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(`Action timed out using timeout of ${timeout}ms.`);
    }, timeout);

    action()
      .then(resp => {
        clearTimeout(timeoutId);
        resolve(resp);
      })
      .catch(err => {
        clearTimeout(timeoutId);
        reject(err);
      });
  });
}
